const headers = {
  name: "Projects",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
    {
      type: "select",
      name: "sort",
      placeholder: "Sort",
      allowClear: true,
      showSearch: false,
      filterOption: true,
      value: null,
      options: [
        { value: 0, label: "Name (A-Z)" },
        { value: 1, label: "Name (Z-A)" },
      ],
    },
    {
      type: "filter",
      name: "status",
      placeholder: "Status",
      value: null,
      allowClear: true,
      showSearch: false,
      filterOption: true,
      options: [
        { value: 0, label: "Inactive" },
        { value: 1, label: "Active" },
      ],
    },
    {
      type: "add",
      path: "/app/projects/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Projects",
        path: "",
      },
      {
        name: "Sliders",
        path: "/app/projects/sliders",
      },
      {
        name: "Gallery",
        path: "/app/projects/gallery",
      },
      {
        name: "Amenities",
        path: "/app/projects/amenities",
      },
      {
        name: "Nearby",
        path: "/app/projects/nearby",
      },
      {
        name: "Types",
        path: "/app/projects/types",
      },
      {
        name: "Plans",
        path: "/app/projects/plans",
      },
    ],
    total: [
      { value: 0, label: "Total" },
      { value: 0, label: "Active" },
      { value: 0, label: "Inactive" },
    ],
  },
};

export default headers;
